import React from 'react';
import { string } from 'prop-types';
import { Button } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/fiverr_context';
import { extractLinkProviderProps, trackEvent } from '../../utils';
import { EVENT_TYPES } from '../../constants';

import './style.scss';

const LinkProvider = ({ email }) => {
    const { providerUrl, providerShortName } = extractLinkProviderProps(email);

    const onClick = () => {
        trackEvent(EVENT_TYPES.INBOX_LINK);
        window.open(providerUrl);
    };

    return providerUrl ? (
        <Button className="link-provider"
            fill={Button.FILLS.GHOST}
            color={Button.COLORS.BLACK}
            textColor={Button.TEXT_COLORS.DARK_GREY}
            onClick={onClick}>
            <I18n k="layout.global_messages.user_activation.go_to_email" params={{ email_provider: providerShortName }}/>
        </Button>
    ) : null;
};

LinkProvider.propTypes = {
    email: string.isRequired
};

export default LinkProvider;
